import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Alert from "sweetalert-react";
import Loading from "../../../components/Loading";
import * as Http from "../../../http";

const REPORT_SHEETS = [
  { key: "HQLA_Classification", label: "HQLA_Classification" },
  { key: "Stable_Classification", label: "Stable_Classification" },
  { key: "PMT_Schedule_Classification", label: "PMT_Schedule_Classification" },
  { key: "Outflow_Classification", label: "Outflow_Classification" },
  { key: "Inflow_Classification", label: "Inflow_Classification" },
  { key: "ASF_Classification", label: "ASF_Classification" },
  { key: "RSF_Classification", label: "RSF_Classification" },
  { key: "DETAIL_RESULT", label: "DETAIL_RESULT" },
];

export default class ReportChild extends Component {
  state = {
    loading: false,
    isShow: false,
    showFileDownloadError: false,
    failedDownloadsList: [],
  };

  onSaveAllFiles = () => {
    const { report } = this.props;
    const fileArr = REPORT_SHEETS.map((s) =>
      Http.makeDownloadLiquidityV2SheetInfo(
        report.file_name,
        report.report_date,
        s.key,
      )
    );
    Http.downloadAllFiles(fileArr, report.report_date, report.file_name).then(
      (result) => {
        if (result && result.is_error) {
          this.setState({
            showFileDownloadError: true,
            failedDownloadsList: result.failed_files || [],
          });
        }
      },
    );
  };

  show = () => {
    this.setState({ isShow: true });
  };

  close = () => {
    this.setState({ isShow: false });
  };

  renderContent = () => {
    const { report } = this.props;
    return (
      <Modal.Body>
        <div className="report-detail-list">
          {REPORT_SHEETS.map((s) => (
            <div className="report-detail-item" key={s.key}>
              <span className="report-detail-name">{s.label}</span>
              <div className="report-detail-actions">
                <button
                  className="report-dl-btn report-dl-xlsx"
                  onClick={() =>
                    Http.downloadLiquidityV2Sheet(
                      report.file_name,
                      report.report_date,
                      s.key,
                    )
                  }
                >
                  <i className="pe-7s-download" /> Download
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="report-detail-footer">
          <button
            type="button"
            className="btn btn-primary report-save-all-btn"
            onClick={this.onSaveAllFiles}
          >
            <i className="pe-7s-download" /> SAVE ALL FILES
          </button>
        </div>
      </Modal.Body>
    );
  };

  renderLoading = () => (
    <div>
      <div style={{ height: 60 }}>
        <Loading size="small" />
      </div>
      <div style={{ height: 30 }} />
    </div>
  );

  render() {
    return (
      <div>
        <a
          href="#url"
          style={{ color: "blue" }}
          onClick={(e) => {
            e.preventDefault();
            this.show();
          }}
        >
          {this.props.report.file_name}
        </a>
        <Modal show={this.state.isShow} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>{this.props.report.file_name}</Modal.Title>
          </Modal.Header>
          {this.state.loading ? this.renderLoading() : this.renderContent()}
        </Modal>
        <Alert
          title="Some Files Failed to Download!"
          text={
            "Please check the following files: " +
            this.state.failedDownloadsList.join(", ")
          }
          show={this.state.showFileDownloadError}
          onConfirm={() => {
            this.setState({ showFileDownloadError: false });
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/LiquidityV2/Reports/ReportChild.js